<template>
    <div class="flex md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <section class="font-poppins w-screen  p-2 md:pl-1 md:pr-1 ">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE ORDERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
                <!-- <p class="mt-3"> <i class="fa fa-angle-left"></i> Go back </p> -->
            <section class="mt-10">
                <TrackOrder/>
            </section>
        </section>
    </div>
</template>

<script>
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import TrackOrder from '../Dashboard/TrackOrder.vue';
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        TrackOrder
    }
}
</script>